var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7844 14.1121C19.053 14.111 19.3109 14.2169 19.5011 14.4063C19.6914 14.5958 19.7984 14.8533 19.7984 15.1218V16.6674C19.7984 18.5079 18.3063 20 16.4657 20H3.32847C1.48953 19.9977 0 18.5063 0 16.6674V15.1218C0 14.5642 0.452098 14.1121 1.00979 14.1121C1.56748 14.1121 2.01958 14.5642 2.01958 15.1218V16.6674C2.0205 17.3897 2.60611 17.975 3.32847 17.9754H16.4657C17.1881 17.975 17.7737 17.3897 17.7746 16.6674V15.1218C17.7746 14.5642 18.2267 14.1121 18.7844 14.1121ZM9.89711 0C10.1311 0 10.3536 0.101548 10.507 0.278333L14.5461 4.92403C14.7537 5.163 14.8026 5.50111 14.6713 5.7891C14.5401 6.07709 14.2528 6.26196 13.9363 6.26209H11.7209C11.6059 6.26209 11.5126 6.35534 11.5126 6.47038V14.0238C11.5126 14.916 10.7893 15.6393 9.89711 15.6393C9.00489 15.6393 8.28161 14.916 8.28161 14.0238V6.47038C8.28161 6.35534 8.18835 6.26209 8.07332 6.26209H5.85795C5.54145 6.26196 5.25416 6.07709 5.1229 5.7891C4.99163 5.50111 5.04056 5.163 5.24807 4.92403L9.28723 0.278333C9.44057 0.101548 9.66308 0 9.89711 0Z",
    fill: "#183028"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.e5d8ca10899ae7818c49edde335fad04.svg";
export { ForwardRef as ReactComponent };